import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useState, useEffect, forwardRef } from 'react';
import { MaterialReactTable } from 'material-react-table';
import { Card, Stack, Button, Container, Typography, IconButton, TableContainer, Snackbar, Alert } from '@mui/material';

// Confirm Delete Import
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

// Material Table Icons Imports
import AddBox from '@mui/icons-material/AddBox';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import Check from '@mui/icons-material/Check';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Clear from '@mui/icons-material/Clear';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import Edit from '@mui/icons-material/Edit';
import FilterList from '@mui/icons-material/FilterList';
import FirstPage from '@mui/icons-material/FirstPage';
import LastPage from '@mui/icons-material/LastPage';
import Remove from '@mui/icons-material/Remove';
import SaveAlt from '@mui/icons-material/SaveAlt';
import Search from '@mui/icons-material/Search';
import ViewColumn from '@mui/icons-material/ViewColumn';
import { CircularProgress } from '@material-ui/core';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';

// User Imports
import NewUser from '../layouts/Clients/NewClient';
import EditNewUser from '../layouts/Clients/EditClient';

// Material Table Icons Defined
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};
export default function Users() {
  const navigate = useNavigate();
  // Hooks
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [editData, setEditData] = useState(null);

  // ---------------------Modal-------------------------------
  const [openModal, setOpenModal] = useState(null);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    fetchData();
  };

  // --------------------- Edit Modal--------------------------
  const [openEditModal, setOpenEditModal] = useState(false);
  const handleOpenEditModal = () => setOpenEditModal(true);
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    fetchData();
  };

  const handleDelete = (_id) => {
    // show the confirmation alert before deleting the row data
    const storedToken = localStorage.getItem('userToken');

    // check if token then parse into json and use it
    const token = storedToken ? JSON.parse(storedToken) : null;
  
    if (token) {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      };
      confirmAlert({
        title: 'Confirm',
        message: 'Are you sure you want to delete this Client ?',
        buttons: [
          {
            label: 'Yes',
            onClick: () => {
              fetch(`https://quotationserver.wisevisionpakistan.com/deleteClient/${_id}`, {
                method: 'DELETE',
                headers,
              })
                .then((response) => {
                  if (!response.ok) {
                    throw new Error('Network response was not ok');
                  }
                  setUsers((prevUsers) => prevUsers.filter((user) => user._id !== _id));
                  setOpenSnackbar(true);
                  
                })
                .catch((error) => {
                  // Handle error
                  console.error('There was an error deleting the employee:', error);
                });
            },
          },
          {
            label: 'No',
            onClick: () => {},
          },
        ],
      });
    } else {
      alert('token not found to delete login first');
    }
  };

  // Fetching Data from an API
  // const fetchData = () => {
  //   fetch('https://quotationserver.wisevisionpakistan.com/showClients').then((result) => {
  //     result.json().then((response) => {
  //       if (response && response.message && response.message.length > 0) {
  //         setUsers(response.message);
  //         setIsLoading(false);
  //       }
  //     });
  //   });
  // };
  const handleLogout = () => {
    setUsers([]);
    const confirmLogout = window.confirm('Your session has expired. Do you want to log out?');
    if (confirmLogout) {
      localStorage.removeItem('userToken');
      navigate('/login');
    }
  };
  const fetchData = () => {
    // get token from local storage
    const storedToken = localStorage.getItem('userToken');

    // check if token then parse into json and use it
    const token = storedToken ? JSON.parse(storedToken) : null;
  
    if (token) {
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      };

      fetch('https://quotationserver.wisevisionpakistan.com/showClients', {
        method: 'GET',
        headers,
      })
        .then((result) => {
          if (result.status === 401) {
            handleLogout();
          } else if (result.ok) {
            result.json().then((response) => {
              if (response && response.message && response.message.length > 0) {
                setUsers(response.message);
                setIsLoading(false);
              }
            });
          } else {
            // Handle other error cases, e.g., network issues or non-401 status codes
            console.error('Error fetching data:', result.status);
          }
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    } else {
      alert('Token is not available. Please log in again.');
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <Helmet>
        <title> DASOL |Clients </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Clients Information
          </Typography>
          <Button variant="contained" onClick={handleOpenModal} startIcon={<Iconify icon="eva:plus-fill" />}>
            New Client
          </Button>
        </Stack>
        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
             
<MaterialReactTable
  columns={[
    {
      accessorKey: 'clientName',
      header: 'Client Name',
      enableSorting: true,
    },
    {
      accessorKey: 'clientDesignation',
      header: 'Designation',
    },
    {
      accessorKey: 'contactNo',
      header: 'Contact No',
    },
    {
      accessorKey: 'clientAddress',
      header: 'Client Address',
    },
    {
      accessorKey: 'company',
      header: 'Company',
    },
    // {
    //   accessorKey: 'country',
    //   header: 'Country',
    // },
    {
      accessorKey: 'actions',
      header: 'Actions',
      Cell: ({ row }) => (
        <>
          <IconButton
            size="large"
            color="inherit"
            onClick={() => {
              setEditData(row.original);
              handleOpenEditModal();
            }}
          >
            <Iconify icon={'eva:edit-fill'} />
          </IconButton>
          <IconButton
            sx={{ color: 'error.main' }}
            size="large"
            color="inherit"
            onClick={() => handleDelete(row.original._id)}
          >
            <Iconify icon={'eva:trash-2-outline'} />
          </IconButton>
        </>
      ),
    },
  ]}
  data={users}
  enablePagination
  enableSorting
  enableColumnFilters
  enableGlobalFilter
  enableRowSelection
  enableColumnResizing
  onRowSelectionChange={(newRowSelection) => console.log(newRowSelection)}
  options={{
    pagination: {
      pageSize: 10,
      pageSizeOptions: [20, 50, 100],
    },
    search: true,
    exportButton: true,
  }}
  muiTableHeadCellProps={{
    style: {
      backgroundColor: '#2065D1',
      color: '#FFF',
    },
  }}
/>
            </TableContainer>
          </Scrollbar>
        </Card>

        {openModal && <NewUser onClose={handleCloseModal} />}
        {openEditModal && <EditNewUser data={editData} onClose={handleCloseEditModal} />}
        <Snackbar
          open={openSnackbar}
          autoHideDuration={1500}
          onClose={() => setOpenSnackbar(false)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert severity="error" variant="filled" sx={{ width: '100%' }}>
            Client Deleted Successfully !
          </Alert>
        </Snackbar>
      </Container>
    </>
  );
}
